import { render, staticRenderFns } from "./crudcampo.vue?vue&type=template&id=d78a2856&scoped=true"
import script from "./crudcampo.vue?vue&type=script&lang=js"
export * from "./crudcampo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78a2856",
  null
  
)

export default component.exports